/**
 * @generated SignedSource<<040e6cb27bc8a5de8180aa5c57f45d10>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RecapTemplateType = "BANT" | "CUSTOMER_SUCCESS" | "MEDDIC" | "SALES_DISCOVERY" | "SALES_FOLLOW_UP" | "SPICED";
export type HighlightsPanelSaveActiveTemplateMutation$variables = {
  meetingRecordingId: string;
  templateType?: RecapTemplateType | null;
};
export type HighlightsPanelSaveActiveTemplateMutation$data = {
  readonly saveActiveTemplate: {
    readonly meetingRecording: {
      readonly activeSummary: {
        readonly activeRecapTemplate: RecapTemplateType | null;
      } | null;
    };
  } | null;
};
export type HighlightsPanelSaveActiveTemplateMutation = {
  response: HighlightsPanelSaveActiveTemplateMutation$data;
  variables: HighlightsPanelSaveActiveTemplateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "meetingRecordingId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "templateType"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "meetingRecordingId",
    "variableName": "meetingRecordingId"
  },
  {
    "kind": "Variable",
    "name": "templateType",
    "variableName": "templateType"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activeRecapTemplate",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HighlightsPanelSaveActiveTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SaveActiveTemplate",
        "kind": "LinkedField",
        "name": "saveActiveTemplate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MeetingRecording",
            "kind": "LinkedField",
            "name": "meetingRecording",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MeetingRecordingSummary",
                "kind": "LinkedField",
                "name": "activeSummary",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HighlightsPanelSaveActiveTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SaveActiveTemplate",
        "kind": "LinkedField",
        "name": "saveActiveTemplate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MeetingRecording",
            "kind": "LinkedField",
            "name": "meetingRecording",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MeetingRecordingSummary",
                "kind": "LinkedField",
                "name": "activeSummary",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "83b06642d68675990763d2cc03c18f09",
    "id": null,
    "metadata": {},
    "name": "HighlightsPanelSaveActiveTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation HighlightsPanelSaveActiveTemplateMutation(\n  $meetingRecordingId: ID!\n  $templateType: RecapTemplateType\n) {\n  saveActiveTemplate(meetingRecordingId: $meetingRecordingId, templateType: $templateType) {\n    meetingRecording {\n      activeSummary {\n        activeRecapTemplate\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "550cb3d92563c2a85cafbe207d57ecd1";

export default node;
